import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  constructor(private router: Router) {}

  getAll() {
    return this.router.parseUrl(this.router.url).queryParams;
  }

  get(name: string): string | null {
    const qp = this.getAll();
    return (qp[name] ?? null) as string | null;
  }
}